// @flow
import type { State as AdvertisementTableState } from './advertisementTable/reducers'
import type { State as AdEditWrapperState } from './adEditWrapper/reducers'
import type { State as RenameCampaignFormState } from './renameCampaignForm/reducers'
import type { State as CopiedAdvertisementListState } from './copiedAdvertisementList/reducers'
import type { State as CopyAdToAudienceState } from './copyAdToAudience/reducers'
import type { State as MediasState } from './media/reducers'
import type { State as AdvertisementsState } from './advertisements/reducers'
import type { State as AudienceEdit } from './audienceEdit/reducers'
import type { State as AdvertisementReplication } from './advertisementReplicas/reducers'
import type { State as AdvertisementTemplate } from './advertisementTemplate/reducers'
import type { State as SegmentationState } from './segmentation/reducers'
import type { State as AudiencesSelectorState } from './audiencesSelector/reducers'
import type { State as AdvertisementTemplateAssignment } from './advertisementTemplatesAssignment/reducers'
import type { State as CampaignTable } from './campaignTable/reducers'
import type { State as LeadformEdit } from './leadformEdit/reducers'
import type { State as Leadforms } from './leadforms/reducers'
import type { State as AdvertisementTemplatesTable } from './advertisementTemplatesTable/reducers'
import type { State as PriceBudgetForm } from './priceBudgetForm/reducers'
import type { State as DescriptionUrlForm } from './descriptionUrlForm/reducers'
import type { State as AgencyPage } from './agencyPage/reducers'
import type { State as StatisticMetricsPage } from './statisticMetricsPage/reducers'
import type { State as ProviderUtmPage } from './providerUtmPage/reducers'
import type { State as AudienceNameTemplatePage } from './audienceNameTemplatePage/reducers'
import type { State as CarouselEdit } from './carouselEdit/reducers'
import type { State as PricelistEdit } from './pricelistEdit/reducers'
import type { State as ImportEntitiesPage } from './importEntitiesPage/reducers'

export { default as advertisementTable } from './advertisementTable/reducers'
export { default as adEditWrapper } from './adEditWrapper/reducers'
export { default as renameCampaignForm } from './renameCampaignForm/reducers'
export { default as copiedAdvertisementList } from './copiedAdvertisementList/reducers'
export { default as copyAdToAudience } from './copyAdToAudience/reducers'
export { default as medias } from './media/reducers'
export { default as advertisements } from './advertisements/reducers'
export { default as audienceEdit } from './audienceEdit/reducers'
export { default as advertisementReplicas } from './advertisementReplicas/reducers'
export { default as advertisementTemplate } from './advertisementTemplate/reducers'
export { default as segmentation } from './segmentation/reducers'
export { default as audiencesSelector } from './audiencesSelector/reducers'
export { default as advertisementTemplateAssignment } from './advertisementTemplatesAssignment/reducers'
export { default as campaignTable } from './campaignTable/reducers'
export { default as leadformEdit } from './leadformEdit/reducers'
export { default as leadforms } from './leadforms/reducers'
export { default as advertisementTemplatesTable } from './advertisementTemplatesTable/reducers'
export { default as priceBudgetForm } from './priceBudgetForm/reducers'
export { default as descriptionUrlForm } from './descriptionUrlForm/reducers'
export { default as agencyPage } from './agencyPage/reducers'
export { default as statisticMetricsPage } from './statisticMetricsPage/reducers'
export { default as providerUtmPage } from './providerUtmPage/reducers'
export { default as audienceNameTemplatePage } from './audienceNameTemplatePage/reducers'
export { default as carouselEdit } from './carouselEdit/reducers'
export { default as pricelistEdit } from './pricelistEdit/reducers'
export { default as importEntitiesPage } from './importEntitiesPage/reducers'

type Store = {|
  advertisementTable: AdvertisementTableState,
  adEditWrapper: AdEditWrapperState,
  renameCampaignForm: RenameCampaignFormState,
  copiedAdvertisementList: CopiedAdvertisementListState,
  copyAdToAudience: CopyAdToAudienceState,
  medias: MediasState,
  advertisements: AdvertisementsState,
  audienceEdit: AudienceEdit,
  advertisementReplicas: AdvertisementReplication,
  advertisementTemplate: AdvertisementTemplate,
  segmentation: SegmentationState,
  audiencesSelector: AudiencesSelectorState,
  advertisementTemplateAssignment: AdvertisementTemplateAssignment,
  campaignTable: CampaignTable,
  leadformEdit: LeadformEdit,
  leadforms: Leadforms,
  advertisementTemplatesTable: AdvertisementTemplatesTable,
  priceBudgetForm: PriceBudgetForm,
  descriptionUrlForm: DescriptionUrlForm,
  agencyPage: AgencyPage,
  statisticMetricsPage: StatisticMetricsPage,
  providerUtmPage: ProviderUtmPage,
  audienceNameTemplatePage: AudienceNameTemplatePage,
  carouselEdit: CarouselEdit,
  pricelistEdit: PricelistEdit,
  importEntitiesPage: ImportEntitiesPage
|}

export type { Store }
